import { render, staticRenderFns } from "./ResultMiddle.vue?vue&type=template&id=bcb9e8ec&scoped=true&"
import script from "./ResultMiddle.vue?vue&type=script&lang=js&"
export * from "./ResultMiddle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb9e8ec",
  null
  
)

export default component.exports